import { render, staticRenderFns } from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=template&id=1c91fb42&scoped=true"
import script from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=style&index=0&id=1c91fb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91fb42",
  null
  
)

export default component.exports